import { createAsyncThunk } from "@reduxjs/toolkit";
import { CONTACT_US } from "../action-types";
import { showAlert } from "../slices/features/alert";
import { getBaseUrl } from "../selectors/features";
import { ContactUsService } from "@root/services";
import { t } from 'i18next';
import { TOAST_VARIANT } from "@root/constants/common";


const contactUsService = new ContactUsService();

interface ContactUsPayload {
  payload: Record<string, string>;
  onSuccess: any;
  errorCallback: any;
  onError: any;
  selectedFile?: any;
  sucessCallback: () => void;
}

export const contactUs = createAsyncThunk<TObject, TObject, IActionOptions>(
  CONTACT_US,
  async (requestPayload: ContactUsPayload, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { payload, sucessCallback, selectedFile , errorCallback} = requestPayload;
    const { email, full_name, message, phone } = payload;

    const formData: allAnyTypes = new FormData();
    formData.append('email', email);
    formData.append('full_name', full_name);
    formData.append('message', message);
    formData.append('phone', phone);
    formData.append('file', selectedFile);
    const { data, error } = await contactUsService.contactUs(baseUrl, formData);

    if (error) {
      thunkAPI.dispatch(
        showAlert({
          message:
            data?.message || data?.userMessage || data?.code || data || "",
          type: TOAST_VARIANT.ERROR,
        })
      );
      if (typeof errorCallback === 'function') {
        errorCallback()
      }
      return thunkAPI.rejectWithValue(data);
    } else {
      if (typeof sucessCallback === "function") {
        sucessCallback();
      }
      thunkAPI.dispatch(
        showAlert({
          message: t('common:contact.submission'),
          type: TOAST_VARIANT.SUCCESS,
        })
      );
    }
    return thunkAPI.fulfillWithValue(data);
  }
);
